import type { CurrentUser } from "@/context/AuthContext";
import { baza } from "@/lib/baza";

/**
 * Who was signed in last, kept on the device — ADR-0004 §2.7.
 *
 * Without this, offline entry does not survive the app being closed, which on
 * iOS happens the moment the manager switches to another app. On the next
 * start there is no access token — it only ever lived in memory — and the
 * refresh call cannot reach the server, so the app would show the login screen
 * to somebody standing on a site with no signal. He could not see his crew and
 * could not enter anything, which is the entire feature gone.
 *
 * §2.7 settles what to do: **entering into the local queue does not require a
 * valid token.** This is how that is possible. It decides which screen to
 * show, not what anybody may do — every entry is still authorised by the
 * server when it is finally sent, and the author travels with the entry
 * (`unio_korisnik_id`) rather than being inferred from whoever is signed in by
 * then.
 *
 * Signing out clears this. That is a deliberate act by a person, unlike a
 * token expiring, and it must leave the phone with no session to resume — the
 * queue itself stays, because "odjava nikad ne briše nespremljene unose".
 */

const KLJUC = "zadnji";

export async function spremiIdentitet(korisnik: CurrentUser): Promise<void> {
  await (await baza()).put("korisnik", korisnik, KLJUC);
}

export async function procitajIdentitet(): Promise<CurrentUser | null> {
  return (await (await baza()).get("korisnik", KLJUC)) ?? null;
}

export async function obrisiIdentitet(): Promise<void> {
  await (await baza()).delete("korisnik", KLJUC);
}
